export default [
    {
        path: 'procedimento',
        component: () => import(
            '@/views/atencao-basica/procedimento/Index'
        ),
        redirect: 'procedimento/index',
        children: [
            {
                name: 'atencao-basica-procedimento',
                path: 'index',
                props: true,
                component: () => import(
                    '@/views/atencao-basica/procedimento/List'
                ),
            },
            {
                name: 'atencao-basica-procedimento-create',
                path: 'create',
                component: () => import(
                    '@/views/atencao-basica/procedimento/Form'
                )
            },
            {
                name: 'atencao-basica-procedimento-edit',
                path: 'edit/:id',
                component: () => import(
                    '@/views/atencao-basica/procedimento/Form'
                )
            },
        ],
    },
]